<ion-content [fullscreen]="true">
  <ion-grid style="max-width: 1100px">
    <!--logo på toppen-->
    <ion-row>
      <ion-col
        size="4"
        offset="4"
        size-sm="2"
        offset-sm="5"
        size-md="2"
        offset-md="5"
        class="p-3"
      >
        <img src="/assets/img/Ishavskraftlogo.svg" />
      </ion-col>
    </ion-row>

    <!-- artikkel -->
    <ion-row class="article-page">
      <ion-col
        size="12"
        offset="0"
        size-md="10"
        offset-md="1"
        size-lg="8"
        offset-lg="2"
        size-xl="8"
        offset-xl="2"
        class="p-3"
      >
        <div class="articlepage" *ngIf="article">
          <ion-row>
            <ion-col size="12" size-md="6" class="">
              <!-- button tilbake til...-->
              <p (click)="navBack()" class="tilbake-knapp-artikkel">
                <i class="fas fa-long-arrow-alt-left p-r-3"></i>Tilbake
              </p>
            </ion-col>
          </ion-row>
          <ion-row class="ion-justify-content-center">
            <ion-col>
              <!--Overskrift+ingress-->
              <h1>{{article.title}}</h1>
              <p class="cr-ingress" id="ingress">{{article.lead}}</p>
            </ion-col>
          </ion-row>
          <ion-row class="ion-justify-content-center">
            <ion-col size="12" size-md="12" class="aspect-ratio-box-16_9">
              <img
                class="rounded bilde-artikkel-nyttig"
                [alt]="article.image.alt"
                [src]="article.image.src"
                [srcset]="article.image.srcset"
              />
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12" class="margin-around-content">
              <!--innhold artikkel-->
              <span
                class="artikkel-innhold"
                id="artikkel"
                [innerHTML]="articleContent"
              ></span>

              <div *ngIf="article.discount_key" class="m-t">
                <ion-button
                  class="button button-success"
                  id="min-rabatt"
                  (click)="getRabattkode(article)"
                  >Hent din rabattkode</ion-button
                >
                <ion-modal
                  trigger="min-rabatt"
                  class="rabattkode-modal-content"
                >
                  <ng-template>
                    <div class="modalClose">
                      <img
                        src="/assets/img/shared/close.svg"
                        (click)="cancel()"
                      />
                    </div>
                    <ion-content class="modal-rabatt-innhold">
                      <h2>Din rabattkode</h2>
                      <div *ngIf="rabattResponse | async; else loadingTemplate">
                        <div *ngIf="rabattkode">
                          <div class="rabattcontainer">
                            <p class="rkode">{{rabattkode}}</p>
                            <span
                              class="pointer"
                              (click)="copyToClipboard(rabattkode, article.discount_key)"
                            >
                              <ion-icon name="copy-outline"></ion-icon>
                              Kopiér
                            </span>
                          </div>
                          <p class="rtext">
                            Kopiér rabattkoden over og bruk den ved bestilling!
                          </p>
                        </div>
                        <p *ngIf="!rabattkode">
                          Vi finner dessverre ingen rabattkode for øyeblikket...
                        </p>
                      </div>
                    </ion-content>
                  </ng-template>
                </ion-modal>
              </div>

              <!--button for linkartikkel_s-->
              <ion-button
                *ngIf="article.link_article && article.link_article.active"
                class="dark m-block"
              >
                <a
                  [href]="article.link_article.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  (click)="logClick(article)"
                  >{{article.link_article.linktext}}<ion-icon
                    name="open-outline"
                  ></ion-icon
                ></a>
              </ion-button>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12">
              <!-- button tilbake til...-->
              <p (click)="navBack()" class="tilbake-knapp-artikkel">
                <i
                  class="fas fa-long-arrow-alt-left"
                  style="padding-right: 10px"
                ></i
                >Tilbake
              </p>
            </ion-col>
          </ion-row>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="tab-content-bottom-margin"></div>
</ion-content>

<ng-template #loadingTemplate>
  <div class="loadingContainer">
    <ion-spinner name="dots"></ion-spinner>
  </div>
</ng-template>
